import { Logo } from '@/components/branding/Logo';
import { Skeleton, SkeletonCard } from '@/components/skeletons/Skeleton';
import { cn } from '@/utils/cn';

type StartupLoaderProps = {
  title?: string;
  subtitle?: string;
  className?: string;
};

export function StartupLoader({
  title = 'Starting AarogyaFlow',
  subtitle = 'Loading your clinic workspace',
  className
}: StartupLoaderProps) {
  return (
    <div
      role="status"
      aria-label={title}
      className={cn(
        'flex min-h-screen items-center justify-center overflow-hidden bg-slate-50 px-6 text-slate-900 transition-colors dark:bg-slate-950 dark:text-slate-100',
        className
      )}
    >
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top,rgba(59,130,246,0.14),transparent_30%),radial-gradient(circle_at_bottom_right,rgba(24,142,196,0.16),transparent_28%)]" />
      <div className="pointer-events-none absolute left-[-10%] top-[-12%] h-72 w-72 rounded-full bg-brand-500/10 blur-3xl dark:bg-brand-400/15" />
      <div className="pointer-events-none absolute bottom-[-12%] right-[-10%] h-72 w-72 rounded-full bg-sky-500/10 blur-3xl dark:bg-sky-500/15" />

      <SkeletonCard className="relative w-full max-w-sm border-slate-200/80 bg-white/90 px-6 py-8 text-center backdrop-blur dark:border-slate-800 dark:bg-slate-900/90">
        <div className="mx-auto flex w-full max-w-[18rem] flex-col items-center gap-5">
          <div className="flex h-24 w-24 items-center justify-center rounded-[1.8rem] bg-slate-100 shadow-sm ring-1 ring-slate-200/70 dark:bg-slate-800 dark:ring-slate-700/80">
            <Logo variant="icon" className="h-16 w-16" />
          </div>

          <div className="space-y-2">
            <p className="text-[0.72rem] font-semibold uppercase tracking-[0.34em] text-brand-600 dark:text-brand-400">AarogyaFlow</p>
            <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
            <p className="text-sm leading-6 text-slate-500 dark:text-slate-400">{subtitle}</p>
          </div>

          <div className="w-full space-y-3">
            <Skeleton className="h-2.5 w-full rounded-full" />
            <div className="grid grid-cols-3 gap-2">
              <Skeleton className="h-16 rounded-[1rem]" />
              <Skeleton className="h-16 rounded-[1rem]" />
              <Skeleton className="h-16 rounded-[1rem]" />
            </div>
          </div>
        </div>
      </SkeletonCard>
    </div>
  );
}

